import * as React from "react";
import { WhiteSpaceProperty } from "csstype";

export default block => {
  if (block.getType() === "atomic") {
    return {
      component: getCustomComponent,
      editable: false
    };
  }

  return null;
};

// 返回自定义组件
const getCustomComponent = props => {
  try {
    const entity = props.contentState.getEntity(props.block.getEntityAt(0));
    const {
      data: { src, title }
    } = entity.getData();
    const type = entity.getType();

    let media = transformMedia(type, title, src);

    return media;
  } catch (error) {
    console.error(error);
    return <span />;
  }
};

const styles = {
  root: {
    fontFamily: "'Georgia', serif"
    // padding: 20
    // width: 600
  },
  buttons: {
    marginBottom: 10
  },
  urlInputContainer: {
    marginBottom: 10
  },
  urlInput: {
    fontFamily: "'Georgia', serif",
    marginRight: 10,
    padding: 3
  },
  editor: {
    border: "1px solid #ccc",
    cursor: "text",
    minHeight: 80,
    padding: 10
  },
  button: {
    marginTop: 10,
    textAlign: "center"
  },
  media: {
    width: 80,
    whiteSpace: "initial" as WhiteSpaceProperty
  }
};

// 视频
const Audio = props => {
  return <audio controls src={props.src} style={styles.media} />;
};

// 图片
const Image = props => {
  return <img src={props.src} style={styles.media} />;
};

// 音频
const Video = props => {
  return <video controls src={props.src} style={styles.media} />;
};

// file
const File = props => {
  let iconClassName = "",
    text = props.title;
  switch (props.type) {
    case "excel":
      iconClassName = "action-web-icon-";
      break;
    case "word":
      iconClassName = "action-word";
      break;
    case "url":
      iconClassName = "action-web-icon-1";
      text = props.src.trim();
      break;
    case "txt":
    default:
      iconClassName = "action-txt";
      break;
  }
  return (
    <div>
      <a href={props.src} target="_blank">
        <i className={`action-user ${iconClassName}`} />
        {text}
      </a>
    </div>
  );
};

// 转换自定义组件
const transformMedia = (type, title, src) => {
  let media: any = null;
  if (type === "audio") {
    media = <Audio src={src} />;
  } else if (type === "image") {
    media = <Image src={src} />;
  } else if (type === "video") {
    media = <Video src={src} />;
  } else {
    media = <File src={src} title={title} type={type} />;
  }

  return media;
};
